import React, { Component } from 'react';

type LocaleUtils = {
  formatWeekdayLong: (weekday: number, locale?: string) => string;
  formatWeekdayShort: (weekday: number, locale?: string) => string;
};

type WeekdayProps = {
  weekday?: number;
  className?: string;
  locale?: string;
  localeUtils?: LocaleUtils;
  weekdaysLong?: Array<string>;
  weekdaysShort?: Array<string>;
};

export default class Weekday extends Component<WeekdayProps> {
  shouldComponentUpdate(nextProps: WeekdayProps) {
    return this.props !== nextProps;
  }

  render() {
    const { weekday = 0, className, weekdaysLong, weekdaysShort, localeUtils, locale } = this.props;
    let title;
    if (weekdaysLong) {
      title = weekdaysLong[weekday];
    } else {
      title = localeUtils?.formatWeekdayLong(weekday, locale);
    }
    let content;
    if (weekdaysShort) {
      content = weekdaysShort[weekday];
    } else {
      content = localeUtils?.formatWeekdayShort(weekday, locale);
    }

    return (
      <div className={className} role="columnheader">
        <abbr title={title}>{content}</abbr>
      </div>
    );
  }
}
